import { render } from "./TopHead.vue?vue&type=template&id=631eef7e&scoped=true"
import script from "./TopHead.vue?vue&type=script&lang=js"
export * from "./TopHead.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-631eef7e"

export default script